import { useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import { AIComponentsContext } from '../providers/AIComponents.provider';

export const useQueryClientSingleton = () => {
  const { queryClientCtx } = useContext(AIComponentsContext);

  return useQueryClient({ context: queryClientCtx });
};
